import { diContainer } from '../DIContainer';
import { Store } from '../wrappers';
import { configEn, configMe, configSr, configBa } from 'app-resources';
import { Model } from '../models';
import { OrderLocalizationMe } from '../models/localization/OrderLocalizationMe';
import { OrderLocalizationSr } from '../models/localization/OrderLocalizationSr';
import { OrderLocalizationBa } from '../models/localization/OrderLocalizationBa';
import { TaxRateLocalizationMe } from '../models/localization/TaxRateLocalizationMe';
import { TaxRateLocalizationSr } from '../models/localization/TaxRateLocalizationSr';
import { TaxRateLocalizationBa } from '../models/localization/TaxRateLocalizationBa';
import { ClientLocalizationBa } from '../models/localization/ClientLocalizationBa';
import { ClientLocalizationSr } from '../models/localization/ClientLocalizationSr';
import { ClientLocalizationMe } from '../models/localization/ClientLocalizationMe';
import { CashRegisterLocalizationMe } from '../models/localization/CashRegisterLocalizationMe';
import { CashRegisterLocalizationSr } from '../models/localization/CashRegisterLocalizationSr';
import { CashRegisterLocalizationBa } from '../models/localization/CashRegisterLocalizationBa';
import { OrderItemLocalizationMe } from '../models/localization/OrderItemLocalizationMe';
import { OrderItemLocalizationSr } from '../models/localization/OrderItemLocalizationSr';
import { ReportLocalizationMe } from '../models/localization/ReportLocalizationMe';
import { ReportLocalizationSr } from '../models/localization/ReportLocalizationSr';
import { ReportLocalizationBa } from '../models/localization/ReportLocalizationBa';
export class I18n {
    static locales = ['me', 'ba', 'sr', 'en'];
    static get $i18n() {
        return diContainer.resolve('i18n');
    }
    static setLocale(locale) {
        I18n.$i18n.locale.value = locale;
    }
    static t(key, ...values) {
        return I18n.$i18n.t(key, ...values);
    }
    static tc(key, count, values) {
        return I18n.$i18n.t(key, { count, ...values });
    }
    static getConfig(customLocale) {
        const locale = customLocale || Store.get('locale');
        switch (locale) {
            case 'me':
                return configMe;
            case 'sr':
                return configSr;
            case 'ba':
                return configBa;
            default:
                return configEn;
        }
    }
    static c(key, customLocale) {
        const config = this.getConfig(customLocale);
        return config[key];
    }
    static getLocales() {
        return this.locales.map(locale => {
            return {
                value: locale,
                country: this.t(`locales.${locale}`),
                alpha3Code: this.c('general.country', locale),
                domain: this.c('general.domain', locale)
            };
        });
    }
}
export function LocaleOverride(target, propertyName, descriptor) {
    const originalMethod = descriptor.value;
    descriptor.value = function (...args) {
        const isStaticMethod = target.constructor === Function;
        const className = isStaticMethod ? Model.getModelName(target) : Model.getModelName(target.constructor);
        let localization = className
            ? (isStaticMethod ? getLocalization(className) : getLocalization(className, this))
            : undefined;
        if (localization && typeof localization[propertyName] === 'function') {
            return localization[propertyName].apply(localization, args);
        }
        else {
            return originalMethod.apply(this, args);
        }
    };
}
function getLocalization(className, context) {
    if (className === 'CashRegister') {
        return getCashRegisterLocalization(context);
    }
    else if (className === 'Client') {
        return getClientLocalization(context);
    }
    else if (className === 'OrderItem') {
        return getOrderItemLocalization(context);
    }
    else if (className === 'Order') {
        return getOrderLocalization(context);
    }
    else if (className === 'TaxRate') {
        return getTaxRateLocalization(context);
    }
    else if (className === 'Report') {
        return getReportLocalization(context);
    }
    return undefined;
}
function getCashRegisterLocalization(cashRegister) {
    const locale = Store.get('locale');
    switch (locale) {
        case 'me':
            return cashRegister ? new CashRegisterLocalizationMe(cashRegister) : CashRegisterLocalizationMe;
        case 'sr':
            return cashRegister ? new CashRegisterLocalizationSr(cashRegister) : CashRegisterLocalizationSr;
        case 'ba':
            return cashRegister ? new CashRegisterLocalizationBa(cashRegister) : CashRegisterLocalizationBa;
        default:
            return undefined;
    }
}
function getClientLocalization(client) {
    const locale = Store.get('locale');
    switch (locale) {
        case 'me':
            return client ? new ClientLocalizationMe(client) : ClientLocalizationMe;
        case 'sr':
            return client ? new ClientLocalizationSr(client) : ClientLocalizationSr;
        case 'ba':
            return client ? new ClientLocalizationBa(client) : ClientLocalizationBa;
        default:
            return undefined;
    }
}
function getOrderItemLocalization(orderItem) {
    const locale = Store.get('locale');
    switch (locale) {
        case 'me':
            return orderItem ? new OrderItemLocalizationMe(orderItem) : OrderItemLocalizationMe;
        case 'sr':
            return orderItem ? new OrderItemLocalizationSr(orderItem) : OrderItemLocalizationSr;
        default:
            return undefined;
    }
}
function getOrderLocalization(order) {
    const locale = Store.get('locale');
    switch (locale) {
        case 'me':
            return order ? new OrderLocalizationMe(order) : OrderLocalizationMe;
        case 'sr':
            return order ? new OrderLocalizationSr(order) : OrderLocalizationSr;
        case 'ba':
            return order ? new OrderLocalizationBa(order) : OrderLocalizationBa;
        default:
            return undefined;
    }
}
function getTaxRateLocalization(taxRate) {
    const locale = Store.get('locale');
    switch (locale) {
        case 'me':
            return taxRate ? new TaxRateLocalizationMe(taxRate) : TaxRateLocalizationMe;
        case 'sr':
            return taxRate ? new TaxRateLocalizationSr(taxRate) : TaxRateLocalizationSr;
        case 'ba':
            return taxRate ? new TaxRateLocalizationBa(taxRate) : TaxRateLocalizationBa;
        default:
            return undefined;
    }
}
function getReportLocalization(report) {
    const locale = Store.get('locale');
    switch (locale) {
        case 'me':
            return report ? new ReportLocalizationMe(report) : ReportLocalizationMe;
        case 'sr':
            return report ? new ReportLocalizationSr(report) : ReportLocalizationSr;
        case 'ba':
            return report ? new ReportLocalizationBa(report) : ReportLocalizationBa;
        default:
            return undefined;
    }
}
//# sourceMappingURL=I18n.js.map